export default __webpack_public_path__ + "static/body-bg-770a322be115554352948f261b3b8bf6.jpg";